import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue-demi';
import AbTitle from '../AbTitle/AbTitle.vue';
import AbDescription from '../AbDescription/AbDescription.vue';
import { useCdnImg } from '@webplatform/cdn-image';
import { TextAlign } from '../../../types';

interface Props {
  title?: string;
  titleTag?: string;
  description?: string;
  textAlign?: TextAlign;
  images?: {
    mobile: {
      src: string;
    };
    tablet: {
      src: string;
    };
    desktop: {
      src: string;
    };
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AbBanner',
  props: {
    title: null,
    titleTag: null,
    description: null,
    textAlign: null,
    images: null
  },
  setup(__props: any) {

const props = __props as {
  title?: string;
  titleTag?: string;
  description?: string;
  textAlign?: TextAlign;
  images?: {
    mobile: {
      src: string;
    };
    tablet: {
      src: string;
    };
    desktop: {
      src: string;
    };
  };
};



const isContentExists = computed(() => {
  return props.title || props.description;
});
const isImagesExists = computed(() => {
  const isImagesObjectExist = props.images;
  const isImagesObjectTypesNotExists =
    isImagesObjectExist &&
    !props.images.mobile &&
    !props.images.tablet &&
    !props.images.desktop;
  const isImagesTypesSrcNotExist =
    !isImagesObjectTypesNotExists &&
    !props.images?.mobile.src &&
    !props.images?.tablet.src &&
    !props.images?.desktop.src;

  if (!isImagesObjectExist) return false;
  if (isImagesObjectTypesNotExists) return false;
  if (isImagesTypesSrcNotExist) return false;
  return true;
});

const { generateUrl } = useCdnImg();

return { __sfc: true,props, isContentExists, isImagesExists, generateUrl, AbTitle, AbDescription }
}

})